import React, { useState } from 'react';
import { Send, X, Mail } from 'lucide-react';

const CLOUD_FUNCTION_URL = process.env.REACT_APP_CLOUD_FUNCTION_URL;

const EmailModal = ({ contact, onClose }) => {
  const [emailData, setEmailData] = useState({ to: contact.email, subject: 'Oferta de Terreno - Incorporação', body: '' });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSending(true); setError(null);
    if (!CLOUD_FUNCTION_URL) {
        setError("URL da Cloud Function não configurada no arquivo .env");
        setSending(false);
        return;
    }
    try {
      const response = await fetch(CLOUD_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: emailData.to, subject: emailData.subject, body: emailData.body }),
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Falha ao enviar e-mail');
      }
      alert('E-mail enviado com sucesso!');
      onClose();
    } catch (err) {
      console.error("Erro no envio:", err);
      setError(err.message);
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4">
        <div className="p-6 border-b flex items-center justify-between"><h3 className="text-xl font-semibold text-slate-800 flex items-center gap-2"><Mail className="text-blue-600" />Enviar Email</h3><button onClick={onClose} className="text-slate-400 hover:text-slate-600"><X size={24} /></button></div>
        {error && (<div className="m-6 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm"><strong>Erro:</strong> {error}</div>)}
        <form onSubmit={handleSubmit} className="p-6 pt-0 space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3"><div className="font-medium text-slate-800">{contact.first_name} {contact.last_name}</div><div className="text-sm text-slate-600">{contact.empresas?.empresa}</div></div>
          <div><label className="block text-sm font-medium text-slate-700 mb-1">Para:</label><input type="email" value={emailData.to} onChange={(e) => setEmailData({...emailData, to: e.target.value})} className="w-full px-3 py-2 border rounded-lg" required/></div>
          <div><label className="block text-sm font-medium text-slate-700 mb-1">Assunto:</label><input type="text" value={emailData.subject} onChange={(e) => setEmailData({...emailData, subject: e.target.value})} className="w-full px-3 py-2 border rounded-lg" required/></div>
          <div><label className="block text-sm font-medium text-slate-700 mb-1">Mensagem:</label><textarea value={emailData.body} onChange={(e) => setEmailData({...emailData, body: e.target.value})} rows={10} className="w-full px-3 py-2 border rounded-lg" placeholder="Digite sua mensagem aqui..." required/></div>
          <div className="flex gap-3 pt-4"><button type="button" onClick={onClose} className="flex-1 px-4 py-2 border rounded-lg hover:bg-slate-50">Cancelar</button><button type="submit" disabled={sending} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center gap-2"><Send size={18} />{sending ? 'Enviando...' : 'Enviar Email'}</button></div>
        </form>
      </div>
    </div>
  );
};
export default EmailModal;